export function calcCountValue(rows, ingredients) {
  let tot = 0;
  for (const r of rows) {
    const ig = ingredients.find(x => x.id === r.ingredient_id);
    if (!ig) continue;
    const cp = Number(r.unit_cost) > 0 ? Number(r.unit_cost) : ig.cp;
    const ppc = Number(r.ppc_at_count) > 0 ? Number(r.ppc_at_count) : (ig.ppc || 1);
    tot += (parseFloat(r.cases) || 0) * cp + (parseFloat(r.open_qty) || 0) * (cp / ppc);
  }
  return tot;
}

export function getInventoryCOGS(allCountRows, ingredients, rangeStart, rangeEnd, purchases) {
  // Group rows by date
  const byDate = {};
  for (const r of allCountRows) {
    if (!byDate[r.date]) byDate[r.date] = [];
    byDate[r.date].push(r);
  }

  // Filter to usable count dates (>50 rows = a real full count, not a partial)
  const usableDates = Object.keys(byDate).filter(d => byDate[d].length > 50).sort();

  // Find bracket dates
  const beginDate = usableDates.filter(d => d <= rangeStart).pop() || null;
  const endDate = usableDates.filter(d => d <= rangeEnd).pop() || null;

  if (!beginDate || !endDate) return null;

  const beginValue = calcCountValue(byDate[beginDate], ingredients);
  const endValue = calcCountValue(byDate[endDate], ingredients);

  return {
    beginDate,
    beginValue,
    endDate,
    endValue,
    cogs: beginValue + purchases - endValue,
  };
}
